export default __webpack_public_path__ + "static/media/28_4_1.76f7e7f6.png";